import { render } from "./InfoEmployees.vue?vue&type=template&id=7c4d38fe&scoped=true"
import script from "./InfoEmployees.vue?vue&type=script&lang=js"
export * from "./InfoEmployees.vue?vue&type=script&lang=js"

import "./InfoEmployees.vue?vue&type=style&index=0&id=7c4d38fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4d38fe"]])

export default __exports__